import { postApi } from "./getApiBase";
import { jwtSign } from "./jwt";

type NetworkArgs = {
  referral: string;
  address: string;
};

type CaucusArgs = {
  address: string;
};
export const networkMint = async (args: NetworkArgs) => {
  const encrypted = jwtSign(args);

  const mint = await postApi("mint/network", encrypted);

  return await mint.json();
};

export const caucusMint = async (args: CaucusArgs) => {
  const encrypted = jwtSign(args);

  const mint = await postApi("mint/caucus", encrypted);

  return await mint.json();
};

export const subscriberMint = async (args: CaucusArgs) => {
  const encrypted = jwtSign(args);

  const mint = await postApi("mint/subscriber", encrypted);

  return await mint.json();
};
